export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7893.0f08a68c.jpg";